"use client";
import styles from "./Navbar.module.scss";
import { MenuType, PlatformType } from "../../types/baseTypes";
import { OptionsHeaderType } from "@/types/OptionType";
import { NavigationOptionsType } from "@/types/ModuleOptionsType";
import { Logos } from "./Logos/Logos";
import { Menu } from "./Menu/Menu";
import { Socials } from "./Socials/Socials";
import { Search } from "./Search/Search";
import { LanguageToggle } from "./Language/LanguageToggle";
import { Hamburger } from "./Hamburger/Hamburger";
import { useState, useEffect } from "react";
import { useAppContext } from "../../context/AppContext";
import { FocusTrap } from "@aleksundshantu.com/aunds-utils-react/accessibility";
import { Post } from "@/wp/types/client";

interface NavbarProps {
  menu: MenuType;
  searchPageSlug: string;
  socialMedia: PlatformType;
  navbarOption: NavbarOptionType;
  pageData?: Post;
  isHome: boolean;
}

export type NavbarOptionType = {
  themeOption: OptionsHeaderType;
  moduleOption: NavigationOptionsType;
};

export const Navbar = ({
  navbarOption,
  searchPageSlug,
  menu,
  socialMedia,
  pageData,
  isHome,
}: NavbarProps) => {
  const { logos } = navbarOption.themeOption;
  const {
    show_box_shadow,
    show_social_icons_in_menu,
    show_search,
    show_language,
    show_background,
  } = navbarOption.moduleOption.header_menu;
  const [hasBackground, setHasBackground] = useState<boolean>(false);
  const { openMenu } = useAppContext();

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY || window.pageYOffset;
      setHasBackground(scrollY > 100);
    };

    // Initial check
    handleScroll();

    // Add scroll event listener
    window.addEventListener("scroll", handleScroll, { passive: true });

    // Cleanup
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <header>
      <nav
        data-has-bg={isHome && !show_background ? hasBackground : true}
        data-show-shadow={show_box_shadow}
        //! please dont remove scrollbar-width class
        className={`${styles["navbar"]} ${openMenu ? styles["opened"] : ""} navbar scrollbar-width`}
      >
        <Logos logos={logos} />
        <Hamburger />
        <FocusTrap disabled={!openMenu}>
          <div
            id="navbar-main"
            data-show-search={show_search}
            data-lenis-prevent
            className={`${styles["navbar-main"]} ${openMenu ? styles["opened"] : ""}`}
          >
            <div className={styles["navbar-main-mobile-scroll"]}>
              <Menu menu={menu} pageData={pageData} />
              {show_social_icons_in_menu && <Socials platforms={socialMedia} />}
              {show_language && pageData && (
                <LanguageToggle addWrapper={true} post={pageData} />
              )}
            </div>

            {show_search && <Search searchPageSlug={searchPageSlug} />}
          </div>
        </FocusTrap>
      </nav>
    </header>
  );
};
